export default {
  path: "/statistics",
  name: "statistics",
  component: () => import("@/views/Page.vue"),
  children: [
    {
      path: "index",
      name: "statisticsIndex",
      component: () => import("@/components/statistics/index.vue"),
      meta: {
        title: "使用情况"
      }
    },
    {
      path: "system",
      name: "statisticsSystem",
      component: () => import("@/components/statistics/system.vue"),
      meta: {
        title: "系统分布"
      }
    },
    {
      path: "version",
      name: "statisticsVersion",
      component: () => import("@/components/statistics/version.vue"),
      meta: {
        title: "版本分布"
      }
    }
  ]
};
